import React from 'react';
import { ChevronRightSmall } from '@wix/wix-ui-icons-common';
import { dataHooks } from '../constants';
import { classes } from '../SidebarSubMenuNext.st.css.js';
const chevronSuffixJsx = (React.createElement("span", { className: classes.chevronRight },
    React.createElement(ChevronRightSmall, { "data-hook": dataHooks.chevronRight, size: "18px" })));
export const getSuffixWithChevron = (suffix) => {
    if (!suffix) {
        return chevronSuffixJsx;
    }
    return Array.isArray(suffix)
        ? [suffix[0], chevronSuffixJsx]
        : [suffix, chevronSuffixJsx];
};
//# sourceMappingURL=common.js.map